<template>
  <v-dialog :model-value="dialog" max-width="400" @click:outside="close">
    <v-card>
      <v-card-title class="pt-4">{{ createOrUpdate }} project</v-card-title>
      <v-card-text class="pl-4 pt-0">
        <FormRHDHV ref="form" url="projects" :model="project" :formOrder="projectOrder" :dialog="dialog" @form-valid-changed="onFormValidChanged" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          text
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapState } from "vuex"
  import FormRHDHV from "@/components/form/FormRHDHV.vue"

  export default {
    name: "ProjectDialog",
    components: { FormRHDHV },
    data: () => ({
          isFormValid: false,
      project: {
        "id": "",
        "code": "",
        "name": "",
        "client": "",
        "location": ""
      },
      projectOrder: [
        "code",
        "name",
        "client",
        "location"
      ]
    }),
    computed: {
      ...mapState("project", {
        currentProject: state => state.currentProject,
        dialog: state => state.projectDialog,
        loading: state => state.writeLoading
      }),
      createOrUpdate () {
        if (this.currentProject && this.currentProject.id) {
          return "Update"
        } else {
          return "Create"
        }
      },
    },
    watch: {
      dialog (newValue) {
        if (newValue) {
          this.mapObj()
        }
        // Required otherwise the form will throw validation errors
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }
    },
    methods: {
      ...mapActions("project", {
          toggleProjectDialog: "toggleProjectDialog",
          createOrUpdateProject: "createOrUpdateProject"
        }
      ),
      mapObj: function() {
        let keys = Object.keys(this.project)
        keys.forEach(key => this.project[key] = this.currentProject[key])
      },
      onFormValidChanged(value) {
      this.isFormValid = value
        },
      close () {
        this.$refs.form.resetValidation()
        this.toggleProjectDialog(null)
        this.$refs.form.clearModel()
      },
      async save () {
        let formValidation = await this.$refs.form.save()
        if (formValidation.valid) {
          const response = await this.createOrUpdateProject(this.project)
          if (response) {
            this.close()
          } else {
            console.log("Is not valid")
          }
        }
      }
    }

  }
</script>

